const pt = {
  translation: {
    menuPrincipal: {
      home: "Home",
      sobreNos: "Sobre",
      servicos: "Serviços",
      contato: "Contato",
    },
    banner: {
      conectar: "Conectar",
    },
    secaoSobre: {
      titulo: "SOMOS A SAGRES",
      primeiroParagrafo:
        "Inspirados pela histórica Escola de Sagres, que tinha como propósito ensinar a navegar e abrir novas rotas comerciais, nós, da SAGRES, temos o mesmo espírito: promover solução de compra para empresas brasileiras.",
      segundoParagrafo:
        "Com a tecnologia como aliada, reduzimos barreiras e custos, permitindo que nossos clientes se internacionalizem de forma eficiente.",
      terceiroParagrafo:
        "A partir de uma rede global de fornecedores, buscamos sempre o produto ideal para cada necessidade, garantindo conformidade com a legislação brasileira.",
      card: {
        primeiroCard: {
          titulo: "NOSSA MISSÃO",
          descricao:
            "Promover solução de compra para empresas brasileiras, superando as barreiras do comércio internacional.",
        },
        segundoCard: {
          titulo: "NOSSA VISÃO",
          descricao:
            "Ser referência no mercado pela expertise em compra internacional.",
        },
        terceiroCard: {
          titulo: "NOSSOS VALORES",
          descricao:
            "Integridade, transparência nas negociações e comprometimento com a agilidade na entrega dos serviços.",
        },
      },
    },
    secaoDiferencial: {
      titulo: "NOSSOS",
      subtitulo: "DIFERENCIAIS",
      primeiroDiferencial: "AGILIDADE",
      descricaoPrimeiroDiferencial:
        "Base de dados robusta com informações de milhões de empresas em diferentes mercados, potencializando eficiência e rapidez na entrega do serviço contratado.",
      segundoDiferencial: "EXPERTISE",
      descricaoSegundoDiferencial:
        "Equipe de especialistas altamente qualificada em procurement internacional, prontos para identificar os fornecedores certos para o seu negócio.",
      terceiroDiferencial: "CREDIBILIDADE",
      descricaoTerceiroDiferencial:
        "Nossas análises utilizam fontes globais de referência internacional, empregando rigor e consistência em todo o processo de busca.",
    },
    secaoServico: {
      titulo: "", //NOSSO SERVIÇO
      descricao: "", //Pensando em resolver seus problemas, conectamos fornecedores e compradores de maneira fácil e sem burocracias.
      titulos: {
        primeiroTitulo: "NOSSO SERVIÇO: PROCUREMENT",
        subtitulo: "COMO TRABALHAMOS",
      },
      cardInformacao: {
        item1: "Análise inicial",
        desc1:
          "Recebemos sua solicitação, realizamos diagnóstico detalhado e definimos os parâmetros da busca.",
        item2: "Pesquisa global",
        desc2:
          "Utilizamos nossa base de dados com milhões de empresas para identificar potenciais fornecedores.",
        item3: "Triagem qualificada",
        desc3:
          "Contatamos, avaliamos e selecionamos fornecedores com maior potencial de sucesso.",
        item4: "Validação de amostras",
        desc4:
          "Gerenciamos amostras dos fornecedores com mais aderência ao projeto, até a aprovação definitiva.",
        item5: "Custo e operação",
        desc5:
          "Coordenamos sua comunicação com a trading, quando necessário, para o preparo da estimativa de custos de importação e alinhamento operacional.",
      },
    },
    formulario: {
      inputNome: "Seu Nome",
      inputEmail: "Seu E-mail",
      inputMensagem: "Sua Mensagem...",
      titulo: "CONTATO",
      enviar: "Enviar",
    },
    swall: {
      titulo: "Obrigado",
      texto: "E-mail enviado",
    },
    agradecimento: {
      tituloBotao: "Voltar",
    },
  },
};

export { pt };
